import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/veteran-facing-services-tools/veteran-facing-services-tools/packages/documentation/src/layouts/SidebarLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "accessibility-standards"
    }}>{`Accessibility standards`}</h1>
    <h2 {...{
      "id": "three-rules-for-link-and-button-success-sup-idheading33sup"
    }}>{`Three rules for link and button success `}<sup parentName="h2" {...{
        "id": "heading3"
      }}>{`3`}</sup></h2>
    <ol>
      <li parentName="ol">{`Links go to to another page OR jump to an anchor ID in the current page`}
        <ol parentName="li">
          <li parentName="ol">{`SUCCESS CRITERIA:`}</li>
          <li parentName="ol">{`Respond to ENTER keypress`}</li>
          <li parentName="ol">{`The browser URL changes`}</li>
          <li parentName="ol">{`HTML5 history object changes. (Not applicable if using React Router.)`}</li>
          <li parentName="ol">{`Avoid hash route URLs if possible. These interfere with in-page anchor links, and were common with early SPA libraries like Backbone. (Not applicable if using React Router.)`}</li>
          <li parentName="ol">{`Append anchor links to URL when a link points to an in-page anchor ID (skip nav, tabs)`}</li>
          <li parentName="ol">{`Do not add role=“button” to links. Screen readers announce the link as “button”, and changes user`}</li>
          <li parentName="ol">{`Recommended to underline links when in paragraphs or blocks of text`}</li>
        </ol>
      </li>
      <li parentName="ol">{`Buttons perform a UI action`}
        <ol parentName="li">
          <li parentName="ol">{`SUCCESS CRITERIA:`}</li>
          <li parentName="ol">{`Respond to ENTER, SPACEBAR keypresses`}</li>
          <li parentName="ol">{`Perform UI actions that do not change the URL or load a new page`}</li>
        </ol>
      </li>
      <li parentName="ol">{`Call to action links can look like buttons as long as:`}
        <ol parentName="li">
          <li parentName="ol">{`SUCCESS CRITERIA:`}</li>
          <li parentName="ol">{`Load another page URL (see rule #1 success criteria)`}</li>
          <li parentName="ol">{`Announce themselves as “links” to screen readers and assistive devices`}</li>
        </ol>
      </li>
    </ol>
    <h2 {...{
      "id": "common-link-and-button-scenarios-sup-idheading44sup"
    }}>{`Common link and button scenarios `}<sup parentName="h2" {...{
        "id": "heading4"
      }}>{`4`}</sup></h2>
    <ul>
      <li parentName="ul">{`Imagine copy/pasting a URL into a new browser window, sight unseen. Good scenarios for a LINK:`}
        <ul parentName="li">
          <li parentName="ul">{`You expect the page to load scrolled down somewhere`}</li>
          <li parentName="ul">{`You have a call to action that navigates to another page`}</li>
          <li parentName="ul">{`You are loading a second or third tab, pre-selected`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Imagine you are presenting users with an action that does not load a new page. Good scenarios for a BUTTON:`}
        <ul parentName="li">
          <li parentName="ul">{`You have a conditional message that the user should trigger or dismiss`}</li>
          <li parentName="ul">{`You are adding or removing something like a receipt, prescription, appeal`}</li>
          <li parentName="ul">{`Show/hide accordions`}</li>
          <li parentName="ul">{`Submit a form asynchronously`}</li>
          <li parentName="ul">{`Submit an asynchronous request, then redirect users based on the server response. This is a middle ground, but feels like a good case for using a button, considering the original function was asynchronous and might keep users on the same page depending on the response.`}</li>
          <li parentName="ul">{`Open and close a modal dialog`}</li>
          <li parentName="ul">{`Alert boxes or confirmations`}</li>
          <li parentName="ul">{`Do not underline button text. Better to have a halo, background color, or border with plenty of hit space.`}</li>
          <li parentName="ul">{`Underline link text`}</li>
          <li parentName="ul">{`Calls to action links can omit the underline, but would be well served with a design that distinguishes them from buttons. Use these sparingly, maybe one per page.`}</li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      